"use strict";
(function(){
    /**@function ProductEditPage: this function takes a form id or form selector.  It gives us the ability to set up various form features.
     *
     */
    var ProductEditPage = function(formId){
        this.form = formId;
    };

    /**@function dataDependentCheckbox: this function creates a way to listen for the click of data-dependent checkboxes.
     * @attribute data-dependent: is used on checkboxes in order to show or hide a specific div with more questions.
     * @todo Create a way to deal with multiple checkboxes with the same name attributes within the same form.
     */
    ProductEditPage.prototype.dataDependentCheckbox = function(){
        //we have a change event listener for is_ar_type_set. this sets the ar_type value to '0'
        var self = this;
        $(this.form + ' input[data-dependent][ type="checkbox"]').click(function(){
            var dataDependent = $(this).attr('data-dependent');
            var nameAttr = $(this).attr('name');
            var itemsToHide = undefined;

            if(nameAttr !== undefined){
                //TODO: get this working based on notes above.
                itemsToHide = $(self.form + ' [name="'+nameAttr+'"]').not(':checked');
            }

            var isChecked = $(this).is(':checked');
            if(isChecked == true){
                $(self.form + ' ' + dataDependent).show();//item we want to show
            }
            else{
                $(self.form + ' ' + dataDependent).hide();//item[s] we want to hide
            }
        });


        $('[name="is_ar_type_set"]').change(function(){
            if(this.checked == false){
                $('[name="ar_type"]').val('1');
            }
        });
    }

    ProductEditPage.prototype.enableOrDisableJvzooPay = function() {
        var $self = this;
        var $jvzoo_pay_checkbox = $('[name="jvzoo_pay_product_opt_in"]');
        $(this.form + ' input[enable-jvzoo-pay][ type="checkbox"]').click(function(){
            if ($(this).is(':checked')) {
                var enableJvzooPay = $(this).attr('enable-jvzoo-pay');
                if ((enableJvzooPay === 1) && ($(this).is(':checked'))) {
                    $jvzoo_pay_checkbox.enable();
                    return true;
                }
            }

            $jvzoo_pay_checkbox.attr('disabled', 'disabled');
            //loop thru remaining payment types and see if any jvzoo pay enabled ones are checked.
            $('input[enable-jvzoo-pay][ type="checkbox"]').each(function(i, obj) {
                //if its checked
                if ($(this).is(':checked'))
                    $jvzoo_pay_checkbox.enable();
            });
            return true;
        });
    }
    ProductEditPage.prototype.wishListApiKeyCallback = function() {

		var $wishlist_api_key = $('#wishlist_api_key');
		var $wishlist_api_url = $('#wishlist_api_url');
		var $wishlist_api_level = $('[name="wishlist_level"]');
        $wishlist_api_key.change(function () {

            // check to see if api_url is empty, if  yes then exit
            if (!$wishlist_api_url.val()) {
                return false;
            }

            if (!$wishlist_api_key.val()){
                $wishlist_api_level.attr('disabled', 'disabled');
                return false;
            }

            $.ajax({
                url: window.JVZoo.Config.BaseUrl + "/producteditor/productintegrations/getWishlistMemberLevels",
                method: "GET",
                data: {wl_api_url: $wishlist_api_url.val(), wl_api_key: $wishlist_api_key.val()},
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true,
                beforeSend: function() {
                    $wishlist_api_level.empty();
                    $wishlist_api_level.append("<option value='0'>Loading...</option>");
                },
                success: function(data) {
                    $wishlist_api_level.empty();
                    $wishlist_api_level.append("<option value='0'>---Select Membership Level---</option>");
                    $.each(data, function (key, value) {
                        $wishlist_api_level.append($("<option></option>").val(key).html(value));
                    });
                    $wishlist_api_level.removeAttr('disabled');
                },
                error: function(data) {
                    $wishlist_api_level.empty();
                    $wishlist_api_level.append("<option value='0'>---No Levels were found for API URL and Key pair---</option>");
                }
            })
        })
    }

    ProductEditPage.prototype.wishListApiUrlCallback = function() {
        $('[name="wishlist_api_url"]').change(function () {
            var $wishlist_api_key = $('#wishlist_api_key');
            var $wishlist_api_level = $('[name="wishlist_level"]');
            var api_url = $(this).val();

            if (!api_url) {
                $wishlist_api_key.val("");
                $wishlist_api_level.empty();
                $('[name="wishlist_api_key"]').attr('disabled', 'disabled');
            } else {
                $('[name="wishlist_api_key"]').removeAttr('disabled');
            }
        })
    }

      ProductEditPage.prototype.removeOldWishlist = function() {
        var self = this;
        $('[name="oldWishlist"]').click(function () {
            if (confirm('Are you sure you want to remove Wishlist?'))
            {
                <!-- wipe out the download page that was really wishlist integration and reset the secure download checkbox value -->
                $('[name="download_page"]').val("");
                $('[name="wishlist_sku"]').val("");
                $('[name="secure_download"]').val("0");
                $
                $('[name="preApril2018"]').hide();


            }
        })
    }

    /**@function dataDependentRadio: this function creates a way to listen for clicks of data-dependent radio buttons
     * @attribute: data-dependent is used on radio buttons in order to show or hide a specific div with more questions.
     * @var itemsToHide: this gets a collection of the other radio buttons that have the same name attribute within the form.
     */
    ProductEditPage.prototype.dataDependentRadio = function(){
        var self = this;//this allows us to get to any properties on ProductEditPage
        $(this.form + ' input[data-dependent][ type="radio"]').click(function(){
            var dataDependent = $(this).attr('data-dependent');
            var nameAttr = $(this).attr('name');
            var dataDependentAction = $(this).attr('data-dependent-action');
            if(dataDependentAction === 'show'){
                $(dataDependent).show();
            }
            else{
                $(dataDependent).hide();
            }

        });
    }

    /**@function dataDependentSelect: this function is used for showing and hiding data-dependent dataDependentFields
    * 1) your select field should have the data-dependent attribute in order to activate this function
    * 2) data-selected on option tags within a select and set the values to be a selector for a particular tag you want to show
    * 3) the containers you want to hide should have the '.data-dependent-hide' class which hides elements by default.
    *
    */
    ProductEditPage.prototype.dataDependentSelect = function(){
        $(this.form + ' select[data-dependent]').change(function(){
            var nameAttr = $(this).attr('name');
            var dataDependentVal = $(this).val();
            var sectionAttributeToShow = nameAttr + "_" + dataDependentVal;
            $('[data-relation="'+nameAttr+'"]').hide();
            $('[data-show-group="'+sectionAttributeToShow+'"]').show();
        });
    }

    ProductEditPage.prototype.everlessonApiKeyCallback = function() {

        var $everlesson_api_key = $('[name="everlesson_api_key"]');
        var $everlesson_secret_key = $('[name="everlesson_secret_key"]');

        $everlesson_api_key.change(function () {

            if (!$everlesson_api_key.val()) {
                $everlesson_secret_key.attr('disabled', 'disabled');
            } else {
                $everlesson_secret_key.removeAttr('disabled');
            }
        });
    }

    ProductEditPage.prototype.everlessonSecretKeyCallback = function() {
        var $everlesson_secret_key = $('[name="everlesson_secret_key"]');
        var $everlesson_api_key = $('[name="everlesson_api_key"]');
        var $everlesson_membership = $('[name="everlesson_membership"]');

        $everlesson_secret_key.change(function () {
            //<!-- check to see if api_key is empty, if  yes then exit -->
            if (!$everlesson_api_key.val()) {
                return false;
            }
            if (!$everlesson_secret_key.val()){
                $everlesson_membership.attr('disabled', 'disabled');
                return false;
            }
            $.ajax({
                url: window.JVZoo.Config.ApiUrl + "/v2.1/everlesson/getmemberships" + window.JVZoo.Config.XApiTest,
                method: "GET",
                data: {secret_key: $everlesson_secret_key.val(), api_key: $everlesson_api_key.val()},
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true,
                beforeSend: function() {
                    $everlesson_membership.empty();
                    $everlesson_membership.append("<option value='0'>Loading...</option>");
                },
                success: function (data) {
                    $everlesson_membership.empty();
                    $everlesson_membership.append("<option value='0'>---Select Membership---</option>");
                    $.each(data['results'], function (key, value) {
                        $everlesson_membership.append($("<option></option>").val(key).html(value));
                    });
                    $everlesson_membership.removeAttr('disabled');
                },
                error: function (data) {
                    $everlesson_membership.empty();
                    $everlesson_membership.append("<option value='0'>---No Memberships were found for API URL and Key pair.---</option>");
                }
            })
        });
    }

    ProductEditPage.prototype.everlessonMembershipCallback = function() {

        var $everlesson_membership = $('[name="everlesson_membership"]');
        var $everlesson_secret_key = $('[name="everlesson_secret_key"]');
        var $everlesson_api_key = $('[name="everlesson_api_key"]');
        var $everlesson_product = $('[name="everlesson_product"]');

        $everlesson_membership.change(function () {

            //<!-- check to see if api_key is empty, if  yes then exit -->
            if (!$everlesson_secret_key.val() || !$everlesson_api_key.val()) {
                return false;
            }
            if (!$everlesson_membership.val()){
                $everlesson_product.attr('disabled', 'disabled');
                return false;
            }
            $.ajax({
                url: window.JVZoo.Config.ApiUrl + "/v2.1/everlesson/getproducts/" + window.JVZoo.Config.XApiTest,
                method: "GET",
                data: {secret_key: $everlesson_secret_key.val(), api_key: $everlesson_api_key.val(), membership_id: $everlesson_membership.val()},
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true,
                beforeSend: function() {
                    $everlesson_product.empty();
                    $everlesson_product.append("<option value='0'>Loading...</option>");
                },
                success: function (data) {
                    $everlesson_product.empty();
                    $everlesson_product.append("<option value='0'>---Select Product---</option>");
                    $.each(data['results'], function (key, value) {
                        $everlesson_product.append($("<option></option>").val(key).html(value));
                    });
                    $everlesson_product.removeAttr('disabled');
                },
                error: function (data) {
                    $everlesson_product.empty();
                    $everlesson_product.append("<option value='0'>---No Products were found for API URL and Key pair.---</option>");
                }
            })
        });
    }

    ProductEditPage.prototype.everlessonProductCallback = function() {

        var $everlesson_membership = $('[name="everlesson_membership"]');
        var $everlesson_secret_key = $('[name="everlesson_secret_key"]');
        var $everlesson_api_key = $('[name="everlesson_api_key"]');
        var $everlesson_product = $('[name="everlesson_product"]');
        var $everlesson_package = $('[name="everlesson_package"]');

        $everlesson_product.change(function () {
            //<!-- check to see if api_key is empty, if  yes then exit -->
            if (!$everlesson_secret_key.val() || !$everlesson_api_key.val() || !$everlesson_membership.val()) {
                return false;
            }
            if (!$everlesson_product.val()){
                $everlesson_package.attr('disabled', 'disabled');
                return false;
            }
            $.ajax({
                url: window.JVZoo.Config.ApiUrl + "/v2.1/everlesson/getpackages/" + window.JVZoo.Config.XApiTest,
                method: "GET",
                data: {secret_key: $everlesson_secret_key.val(), membership_id: $everlesson_membership.val(), product_id: $everlesson_product.val(), api_key: $everlesson_api_key.val()},
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true,
                beforeSend: function() {
                    $everlesson_package.empty();
                    $everlesson_package.append("<option value='0'>Loading...</option>");
                },
                success: function (data) {
                    $everlesson_package.empty();
                    $everlesson_package.append("<option value='0'>---Select Payment Option---</option>");
                    $.each(data['results'], function (key, value) {
                        $everlesson_package.append($("<option></option>").val(key).html(value));
                    });
                    $everlesson_package.removeAttr('disabled');
                },
                error: function (data) {
                    $everlesson_package.empty();
                    $everlesson_package.append("<option value='0'>---No Packages were found for API URL and Key pair.---</option>");
                }
            })
        });
    }

    ProductEditPage.prototype.everlessonApiLoad = function() {

        var $everlesson_membership = $('[name="everlesson_membership"]');
        var $everlesson_secret_key = $('[name="everlesson_secret_key"]');
        var $everlesson_product = $('[name="everlesson_product"]');
        var $everlesson_package = $('[name="everlesson_package"]');
        var $everlesson_integration = $('[name="everlessonIntegration"]');
        var $everlesson_api_key = $('[name="everlesson_api_key"]');
        $everlesson_integration.ready(function () {

            if (!$everlesson_api_key.val()) {
                $everlesson_secret_key.attr('disabled', 'disabled');
                $everlesson_membership.attr('disabled', 'disabled');
                $everlesson_product.attr('disabled', 'disabled');
                $everlesson_package.attr('disabled', 'disabled');
            }
        });
    }


    /**@function initStickyNavigation: sets up scrollspy on body tag with a target of formMenu.
     * @var targetElement: this is the container that holds the navigation you want to highlight.
     */
    ProductEditPage.prototype.initStickyNavigation = function(targetElement, containerToPad, menuContainer){

        $('body').scrollspy({ target: targetElement });

        $(menuContainer).css('position', 'static');

        if(containerToPad !== undefined){
            $(containerToPad).css({paddingBottom: 200});
        }


        var childrenLength = $('.formMenu li').length;

        $(window).on('scroll', function(){
            //
            var top = (window.pageYOffset || document.scrollTop)  - (document.clientTop || 0);

            if(top < 300){
                $(menuContainer).css('position', 'static');
            }


        });

        //had to use window.on in order to get scrollspy working. It doesn't work any other way despite bootstrap documentation

        $(window).on('activate.bs.scrollspy', function () {
            var top = (window.pageYOffset || document.scrollTop)  - (document.clientTop || 0);
            $(menuContainer).css({"position":"fixed","top": 0});
        });
    }

    /**@function sideBarSaveListener: creates a way for us to click on another button in the sideBar in order to post form data.
     * @var self: refers back to the ProductEditPage
     */
    ProductEditPage.prototype.sideBarSaveListener = function(submitSelector){
        var self = this;
        $(submitSelector).click(function(){
            $('.btn-product-save').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;&nbsp;Saving Product').attr('disabled', true);
            $(self.form).submit();
        });
    }

    /**@function sideBarSaveListener: creates a way for us to click on another button in the sideBar in order to post form data.
     * @var self: refers back to the ProductEditPage
     */
    ProductEditPage.prototype.sideBarDraftListener = function(submitSelector){
        var self = this;
        $(submitSelector).click(function(){
            $('.btn-product-draft').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;&nbsp;Saving Draft');
            $(self.form).submit();
        });
    }

    /**@function dataDependentFields: create a way to listen for all of our different types of data-dendent fields.
     * @method dataDependentSelect: brings in listener for select with data-dependent attr.
     * @method dataDependentCheckbox: brings in listener for checkboxes with data-dependent attr.
     * @method dataDependentRadio: brings in listener for radios with data-dependent attr.
     */
    ProductEditPage.prototype.dataDependentFields = function(){
        //create something to deal with select boxes that are datadependent
        this.dataDependentSelect();
        this.dataDependentCheckbox();
        this.dataDependentRadio();

    }

    ProductEditPage.prototype.setUpDatePicker = function(){
        $('#datetimepicker1').flatpickr({
            enableTime: true,
            dateFormat: "Y-m-d H:i",
            altInput: true,
            altFormat: "m/d/Y H:i"
        });
    }

    ProductEditPage.prototype.modalHelp = function(jsonHelpTextUrl){
        //create a way to get the initial json data structure that holds the help info.
        var helpJson;
        $.getJSON( jsonHelpTextUrl, function( data ) {
            helpJson= data;
            var helpTextData = $('[data-help-text]');
            var missingHelpTags = [];
            for(var item in helpJson){
                var searchElement = $('[data-help-text="'+ item +'"]').html();
                if(searchElement == undefined){
                    missingHelpTags.push(helpJson[item]);
                }
            }

        });


        $(document).on('click', '[data-help-text]', function (event) {
            //get helpText from the helpJson variable
            var helpTextKey = $(this).attr('data-help-text');
            if(helpJson[helpTextKey] !== undefined){
                //do something
                $("#modalHelp .modal-body").html(helpJson[helpTextKey]);
            }
            else{
                event.stopPropagation();
            }
        });

    }

    ProductEditPage.prototype.showDataDependentSections = function(form){
        var dataDependentItemsCheckbox =$( form + " input[type='checkbox'][data-dependent]");

        for(var item in dataDependentItemsCheckbox){
            if(!isNaN(item)){
                var element = dataDependentItemsCheckbox[item];
                var itemChecked = $(element).attr('checked');
                var dataDependent = $(element).attr('data-dependent');
                if(itemChecked == 'checked' ){
                    $(dataDependent).show();
                }
            }
        }

         var dataDependentItemsRadio =$( form + " input[type='radio'][data-dependent][checked]");

        for(var item in dataDependentItemsRadio){
            if(!isNaN(item)){
                var element = dataDependentItemsRadio[item];
                var itemChecked = $(element).attr('checked');
                var dataDependent = $(element).attr('data-dependent');
                var dataDependentAction = $(element).attr('data-dependent-action');
                if(itemChecked == 'checked' && dataDependentAction === 'show' ){
                    $(dataDependent).show();
                }
                else{
                    $(dataDependent).hide();
                }
            }
        }


        var dataDependentItemsSelect =$( form + " select[data-dependent]");
        for(var item in dataDependentItemsSelect){
            if(!isNaN(item)){
                var thisSelect = dataDependentItemsSelect[item];
                var nameAttr = $(thisSelect).attr('name');
                var dataDependentVal = $(thisSelect).val();
                var sectionAttributeToShow = nameAttr + "_" + dataDependentVal;
                $('[data-relation="'+nameAttr+'"]').hide();
                $('[data-show-group="'+sectionAttributeToShow+'"]').show();

            }
        }
    }

    ProductEditPage.prototype.flatCommissionWarning = function () {
        var $price = $('[name="price"]').val();
        $('[name="payout_flat"]').blur(function() {
            var message = 'WARNING! Your Flat Fee Commission Payout is GREATER than your Product Price. You will be losing money with each sale and you will be required to pay the commissions!';
            var flat_payout = $(this).val();
            var flat_payout = (parseFloat(flat_payout));
            if (flat_payout > 0) {
                if (flat_payout > parseFloat($price) * .90) {
                    //show message
                    alert(message)
                }
            }
        })
    };

    ProductEditPage.prototype.confirmation = function(){
        $('[name="cb_payments"]').click(function(){
            var isChecked = $(this).is(':checked');
            var warningChanging = 'Not all Payment Options support recurring payments or subscriptions. Please make sure your Payment Options are still what you want them to be after setting up this section.';
            var questionMessage = 'We are about to disable recurring payments on this product by clearing all of the associated recurring payment values.  Are you trying to disable recurring payments on this product?';
            if(isChecked){
                //only show warningChanging text in an alert
                alert(warningChanging)
            }
            else{
                //show warningChanging and question to be confirmed
                if(confirm(questionMessage)){
                    //remove text values and checked value for payment_trial
                    $('#subscriptionInfo').find('input:text').val('');
                    $('[name="payment_trial"]').prop('checked', false);
                }
                else{
                    //keep the checked value
                    $('[name="cb_payments"]').prop('checked', true);
                }
            }
        });


        $('[name="payment_trial"]').click(function(){
            var isChecked = $(this).is(':checked');
            var questionMessage = 'We are about to disable the trial payment on this product by clearing all of the associated trial payment values.  Are you trying to disable the trial payment on this product?';
            if(isChecked){
                // do nothing
            }
            else{
                //show warningChanging and question to be confirmed
                if(confirm(questionMessage)){
                    //remove text values and checked value for payment_trial
                    $('#trialInfo').find('input:text').val('');
                }
                else{
                    //keep the checked value
                    $('[name="payment_trial"]').prop('checked', true);
                }
            }
        });
    }


    ProductEditPage.prototype.mobileMenu = function(){
        $(".navbar-toggle").click(function(){
            var isVisible = $(".formMenu").is(':visible');
            if(isVisible == false){
                $(".formMenu").addClass('showMobileMenu');
            }
            else{
                $(".formMenu").removeClass('showMobileMenu');
            }
        });
    }


    ProductEditPage.prototype.copyPaypalIpn = function(){
        $("#button-ipn-link").click(function(){
            var $btnCopy = $(this);
            var tgtTxt = $btnCopy.data('copy-target');

            $('#' + tgtTxt).focus();
            $('#' + tgtTxt).select();
            document.execCommand('copy');
            $btnCopy.html('Copied!');
            $btnCopy.toggleClass('btn-secondary btn-success');
        });
    }


    ProductEditPage.prototype.showPaypalIpnInstructions = function(){
        $("#showIpnInstructions").click(function(event){
            event.preventDefault();
            $('#ipn').toggle('slow');
        });
    }

    /** @function enableSelectionOfInputValues: This function allows select elements with the correct attribute to
     * assign the values of input elements with the same attribute value.
     *
     * 1) create an <input> element with the attribute "data-select-hidden-field-group" assigned a value
     * 2) create one or more <select> elements with the attribute "data-select-hidden-field-group" assigned the same
     * value as the target input.
     *
     * Example:
     *
     * <input type="hidden" name="abc" value="" data-select-hidden-field-group="select-group-for-abc">
     *
     * <select class="visible" data-select-hidden-field-group="select-group-for-abc">
     *     <option value="list_0">Email List #0</option>
     *     <option value="list_1">Email List #1</option>
     * </select>
     *
     * <select class="hidden" data-select-hidden-field-group="select-group-for-abc">
     *     <option value="list_0">Email List #0</option>
     *     <option value="list_1">Email List #1</option>
     * </select>
     *
     * First used by the Sendiio AutoResponder elements on the product edit page.
     */
    ProductEditPage.prototype.enableSelectionOfInputValues = function () {
        $("select[data-select-input-value-group]").change(function (element) {
            var selectHiddenFieldGroupName = $(this).attr('data-select-input-value-group');
            var selectedValue = $(this).val();
            if (!selectHiddenFieldGroupName) {
                return;
            }
            var inputSelector = "input[data-select-input-value-group=" + selectHiddenFieldGroupName + "]";
            $(inputSelector).each(function (index, input) {
                $(input).val(selectedValue);
            });
        });
    }


    $(document).ready(function(){
        var productEditFunctions = new ProductEditPage('#myform');
        setTimeout(function(){
            productEditFunctions.showDataDependentSections('#myform');
        },1000);
        productEditFunctions.confirmation();
        productEditFunctions.initStickyNavigation('.backgroundNav','.jvzFormContainer', '.formMenu');
        productEditFunctions.enableSelectionOfInputValues();
        productEditFunctions.everlessonApiKeyCallback();
        productEditFunctions.everlessonApiLoad();
        productEditFunctions.everlessonSecretKeyCallback();
        productEditFunctions.everlessonMembershipCallback();
        productEditFunctions.everlessonProductCallback();
        productEditFunctions.mobileMenu();
        productEditFunctions.wishListApiUrlCallback();
        productEditFunctions.wishListApiKeyCallback();
        productEditFunctions.dataDependentFields();
        productEditFunctions.setUpDatePicker();
        productEditFunctions.sideBarSaveListener('#saveForm');
        productEditFunctions.sideBarDraftListener('#saveDraft');
        productEditFunctions.modalHelp("/assets/json/product-edit-help.json");
        productEditFunctions.removeOldWishlist();
        productEditFunctions.flatCommissionWarning();
        productEditFunctions.enableOrDisableJvzooPay();
        productEditFunctions.copyPaypalIpn();
        productEditFunctions.showPaypalIpnInstructions();
    });
})();